module.exports = __webpack_public_path__ + "img/logo.b53cc000.png";